import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IntegrationService } from '../integration.service';
import { NotifierService } from "angular-notifier";
import { Router } from '@angular/router';
import * as chrono from 'chrono-node'

@Component({
  selector: 'app-subscription-prompt',
  templateUrl: './subscription-prompt.component.html',
  styleUrls: ['./subscription-prompt.component.css']
})
export class SubscriptionPromptComponent implements OnInit {
  private readonly notifier: NotifierService;
  private subscriberId;
  subscriptionPlan;
  constructor(private http:HttpClient,private router:Router,private _integrationService:IntegrationService,notifierService: NotifierService) {
    this._integrationService.userId$.subscribe((data)=>{this.subscriberId=data.replace(/"/g,"")});
    this._integrationService.subscriptionPlan$.subscribe((data)=>{this.subscriptionPlan=data})
    this.notifier = notifierService;
  }
  subscriptionName = localStorage.getItem('subscriptionName') && localStorage.getItem('subscriptionName') != 'undefined' ? localStorage.getItem('subscriptionName') : 'Unknown Subscription'
  subscriptionUrl = localStorage.getItem('subscriptionUrl') && localStorage.getItem('subscriptionUrl') != 'undefined' ? localStorage.getItem('subscriptionUrl') : 'samples.com'
  paymentSched = localStorage.getItem('paymentSched') || 'monthly';
  nextBillingDate = '';
  alternatives = [];
  price = localStorage.getItem('price') && localStorage.getItem('price') != 'undefined' ? localStorage.getItem('price') : 'N/A'
  token = localStorage.getItem('token');

  ngOnInit() {
    // this._integrationService.getUser();
    // this._integrationService.userId$.subscribe((data)=>{this.subscriberId=data.replace(/"/g,"")});
    this._integrationService.showNavSubject.next(false)
    let endpoint = `https://subscrybe-backend.herokuapp.com/get-expiry/${this.subscriptionName.toLowerCase()}`
    this.http.get(endpoint).subscribe(
      data=>{
        let today = new Date()
        today.setDate(today.getDate()+30)
        this.nextBillingDate = data['nextBill'] ? (data['nextBill'] !='N/A' ? data['nextBill'] : (localStorage.getItem('nextBillDate') || today.toISOString().slice(0,10))) : (localStorage.getItem('nextBillDate') || today.toISOString().slice(0,10))
        this.alternatives = data['alternatives'].slice(0,3)
        console.log(this.alternatives)
      }
    )
    let priceEndpoint = `https://subscrybe-backend.herokuapp.com/get-price/${this.subscriptionName.toLowerCase()}`
    this.http.get(priceEndpoint).subscribe(
      data =>{
        this.paymentSched = data['paymentSched'] ? (data['paymentSched']!='N/A' ? data['paymentSched'] : (localStorage.getItem('paymentSched') || 'monthly')) : (localStorage.getItem('paymentSched') || 'monthly')
        this.price = data['price'] ? (data['price']!='N/A' ? data['price'] : (localStorage.getItem('price') || 'N/A')) : (localStorage.getItem('price') || 'N/A');
      }
    )
  }

  updatePrice(value){
    console.log(this.price)
    this.price = value;
    console.log(this.price)
  }

  updateSched(value){
    this.paymentSched = value;
  }

  updateBillingDate(value){
    this.nextBillingDate = value;
  }

  isPaymentSched(received,match){
    switch(match){
      case 'annually':
          return received == 'yearly' || received == 'annually' || received == 'annualy'
      case 'bi-annually':
        return received == 'bi-annually' || received == 'biAnnually' || received == 'biannually'
      case 'quarterly':
        return received == 'quarterly' || received == 'quarter'
      case 'bi-weekly':
          return received == 'bi-weekly' || received == 'biWeekly' || received == 'biweekly'
      case 'weekly':
          return received == 'weekly' || received == 'week'
      case 'monthly':
        return received == 'monthly' || received == 'month'
    }

  }

  add(endSub){
    let reqBody = {
      subscriberId:this.subscriberId,
      subscriptionName:this.subscriptionName,
      subscriptionUrl:this.subscriptionUrl,
      nextBillDate:chrono.parseDate(endSub).toISOString().slice(0,10),
      paymentSched:this.paymentSched ? this.paymentSched : 'monthly',
      price:this.price,
      method:'auto'
    }
    let endpoint = 'https://subscrybe-backend.herokuapp.com/add-subscription'
    this.http.post(endpoint,reqBody).subscribe(
      data=>{
        this.router.navigate(['success'])
      },error=>{
        this.notifier.notify("error", "Error adding subscription,try again");
      }
    )
  }


  getImage(url=''){
    let newUrl = url.replace('https://','').replace('www.','')
    if(newUrl.includes('indeed')){
      return 'https://logo.clearbit.com/www.indeed.com'
    }
    if(newUrl.includes('hulu')){
      return 'https://logo.clearbit.com/hulu.jp'
    }
    console.log(`https://logo.clearbit.com/${newUrl.split('/')[0]}`)
    return `https://logo.clearbit.com/${newUrl.split('/')[0]}`
  }

  openLink(url='subscrybe.app'){
    window.open(url)
  }

  toSettings(){
    window.open('https://my.subscrybe.app/settings')
  }
}
